import React, { Component } from 'react';
import { connect } from 'shalala';
import { withRouter } from 'react-router';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../../store';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../../shared/responses/ResponseResult';
import EmisorSectorPrimarioFiscalInfoForm from '../upsert/components/EmisorSectorPrimarioFiscalInfoForm';
import EmisorSectorPrimarioFiscalAddressForm from '../upsert/components/EmisorSectorPrimarioFiscalAddressForm';

class EmisorSectorPrimarioUpdateFiscalInfo extends Component {
  constructor(props) {
    super(props);

    const { data = {}, tenancy } = props;

    if (tenancy) {
      props.upsertActions.setPartialState({ tenancy });
    }

    props.upsertActions.setPartialState({
      data: data,
      steps: {
        fiscal_info: true,
        fiscal_address: true,
      },
    });
  }

  handleOnSubmit = async () => {
    const {
      data,
      data: { direccion = {} },
    } = this.props.upsert;

    const keys = Object.keys(data);

    let info = {};

    for (const key of keys) {
      if (data[key] !== null) {
        info[key] = data[key];
      }
    }

    delete info.id;
    delete info.status;
    delete info.RegistroPatronal;

    const body = {
      id: data.id,
      ...info,
      sector_primario: true,
      config: {
        mostrar_direccion_en_pdf: !!data.direccion.direccion,
      },
      direccion: direccion,
      nomina: {
        RegistroPatronal: data.RegistroPatronal,
      },
    };

    await this.props.upsertActions.upsert(body, data.id);

    const { result } = this.props.upsert;

    if (!!result && this.props.onComplete) {
      this.props.onComplete(result);
    }
  };

  handleOnDataChange = (event) => {
    let newEvent = {
      ...event,
    };

    this.props.upsertActions.setStepDataChange(newEvent);
  };

  handleOnDataWithStepsChange = (event) => {
    let newEvent = {
      ...event,
      steps: {
        ...this.props.upsert.steps,
        [event.step]: event.isValid,
      },
    };

    this.props.upsertActions.setStepDataChange(newEvent);
  };

  handleOnFiscalAddressDataChange = (event) => {
    let data = {
      ...this.props.data,
      direccion: event.data,
    };

    this.handleOnDataWithStepsChange({
      ...event,
      data,
    });
  };

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.upsert.setPartialState({
        error: undefined,
        __action: action,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    if (!!this.props.onComplete) {
      this.props.onComplete();
    }

    if (action === 'success') {
      setTimeout(() => {
        this.props.history.replace('/app/emisores');
      }, 100);
    }
  };

  renderError = () => {
    const { error } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseResult
          title="Registro actualizado"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { onComplete } = this.props;
    const { steps, data = {}, error, result, busy } = this.props.upsert;
    const isValid = steps.fiscal_info && steps.fiscal_address;

    return (
      <>
        {!!error && this.renderError()}

        {!!result && !onComplete && this.renderResult()}

        <Row>
          <Col
            xs={12}
            sm={12}
            md={10}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">INFORMACIÓN FISCAL</strong>
            </div>

            <EmisorSectorPrimarioFiscalInfoForm
              data={data}
              readOnly={false}
              confirm={false}
              autoFocus={true}
              onFormDataChange={this.handleOnDataWithStepsChange}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={10}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">DOMICILIO FISCAL</strong>
            </div>

            <EmisorSectorPrimarioFiscalAddressForm
              step={'fiscal_address'}
              data={data.direccion ?? {}}
              onFormDataChange={this.handleOnFiscalAddressDataChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
            className="py-3"
          >
            <PopConfirm
              text="Realmente deseas cancelar?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
                className="mr-2"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnSubmit}
            >
              {busy === false ? 'Actualizar' : 'Actualizando...'}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return { upsert: store.app.emisores.upsert };
};

const mapActions = (actions) => {
  return { upsertActions: actions.app.emisores.upsert };
};

export default connect(useStore, mapState, mapActions)(withRouter(EmisorSectorPrimarioUpdateFiscalInfo));
